import { render, staticRenderFns } from "./specialIndex.vue?vue&type=template&id=36c58097&scoped=true"
import script from "./specialIndex.vue?vue&type=script&lang=js"
export * from "./specialIndex.vue?vue&type=script&lang=js"
import style0 from "./specialIndex.vue?vue&type=style&index=0&id=36c58097&prod&lang=scss&scoped=true"
import style1 from "./specialIndex.vue?vue&type=style&index=1&id=36c58097&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c58097",
  null
  
)

export default component.exports